import { isWinStatus, isInProgressStatus, sortEffortsByStatusAndDate } from 'src/utils/statusUtils';

export const getFilteredEffortsData = (queriesByExpert, externalEfforts, statusFilter) => {
  const filteredQueries = Object.values(queriesByExpert || {}).flatMap((expertData) =>
    expertData.queries.filter((query) => statusFilter(query.status))
  );
  const filteredExternalEfforts = (externalEfforts || []).filter((effort) => statusFilter(effort.status));

  const sortedQueries = sortEffortsByStatusAndDate(filteredQueries);
  const sortedExternalEfforts = sortEffortsByStatusAndDate(filteredExternalEfforts, 'date');

  return {
    queries: sortedQueries,
    externalEfforts: sortedExternalEfforts,
    hasData: sortedQueries.length > 0 || sortedExternalEfforts.length > 0,
  };
};

export const getCompanyEffortsData = (queriesByExpert, externalEfforts) => {
  const winsData = getFilteredEffortsData(queriesByExpert, externalEfforts, isWinStatus);
  const effortsData = getFilteredEffortsData(queriesByExpert, externalEfforts, isInProgressStatus);

  return {
    winsData,
    effortsData,
  };
};
